import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export const CONTROL_PROGRAM_TABLE_STATE_STORAGE_KEY = "userControlProgramList";

export const CONTROL_PROGRAM_LIST_COLUMN_IDS = {
    CONTROL_PROGRAM: "controlProgram",
    ACCESS_RIGHT: "accessRight",
    STATUS: "status",
    TAGS: "tags",
} as const;

export const controlProgramListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [
            {
                id: CONTROL_PROGRAM_LIST_COLUMN_IDS.CONTROL_PROGRAM,
                desc: false,
            },
        ],
    };

export const controlProgramListColumnFiltersCodecMap = {
    [CONTROL_PROGRAM_LIST_COLUMN_IDS.CONTROL_PROGRAM]:
        withModeCodec(encodedArrayCodec),
    [CONTROL_PROGRAM_LIST_COLUMN_IDS.ACCESS_RIGHT]:
        withModeCodec(encodedArrayCodec),
    [CONTROL_PROGRAM_LIST_COLUMN_IDS.STATUS]: withModeCodec(encodedArrayCodec),
    [CONTROL_PROGRAM_LIST_COLUMN_IDS.TAGS]: withModeCodec(encodedArrayCodec),
};
